import { Inject, Injectable } from '@angular/core';
import { RestService } from '../../../../../core/services/rest.service';
import { EnedisAccessRightModel, EnedisAccessRightStatus } from '../../enedis.models';

export interface EnedisConsent {
    clientName: string;
    clientRepresentativeName: string;
    clientRepresentativeEmail: string;
    clientSirenSiret: string;
    pdlNumber: string;
    consumptionAccessStart: Date;
    validUntil: Date;
    organization: string;
    status: EnedisAccessRightStatus;
    enedisClientName: string;
}

export interface EnedisConsentStatus {
    status: EnedisAccessRightStatus;
}

@Injectable({
    providedIn: 'root',
})
export class EnedisConsentService {
    constructor(@Inject(RestService) private restService: RestService) {}

    public async getEnedisConsentStatus(token: string): Promise<EnedisConsentStatus> {
        try {
            const path = `/enedis/consent?token=${token}`;
            const result = await this.restService.get(path, {});
            return result as EnedisConsentStatus;
        } catch (err) {
            console.error('Error getting enedis consent status', err);
            throw err;
        }
    }

    public async updateConsent(
        token: string,
        status: EnedisConsentStatus['status'],
    ): Promise<EnedisConsentStatus> {
        try {
            const path = `/enedis/consent`;
            const result = await this.restService.patch(path, {}, { token: token, status: status });
            return result as EnedisConsentStatus;
        } catch (err) {
            console.error('Error updating enedis consent', err);
            throw err;
        }
    }
}
